export default __webpack_public_path__ + "static/Corrupted_video_file-0ea463d0d994f963218459563b2ec5c4.png";